module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-6"
  }, [(_vm.wSat == 1) ? _c('MainTabs', {
    attrs: {
      "pressDat": _vm.resDat,
      "role": "press",
      "bookName": _vm.bookname
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75b89b35"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/SuccessivePart/skimFrame.vue
// module id = 1778
// module chunks = 1